<template>
  <div>
    <div class="clients" :class="{'darkMode' : state.darkMode}">
      <div class="w3-container">
        <div class="headerSearchGrid">
          <div style="grid-area: header;">
            <header>
              <h2>Clients</h2>
            </header>
          </div>
          <div style="grid-area: button;">
            <router-link to="/addClient" class="w3-button w3-green w3-small w3-right vmiddle">
              <i class="fas fa-plus" style="margin-right:8px;"></i>New Client
            </router-link>
          </div>
          <div style="grid-area: search; position:relative;">
            <input class="w3-input w3-dark-grey mbmobile" :class="width > 600 ? 'vmiddle' : ''" placeholder="Search Clients..." v-model="state.admin.global.clients.searchClientTerm" @keyup="searchClient()" />
            <button v-if="state.admin.global.clients.searchClientTerm !== '' && state.admin.global.clients.searchClientTerm !== null" class="w3-button w3-text-white" style="position: absolute; top:50%; right:0; transform:translateY(-50%);" @click="clearSearch()"><i class="fas fa-times"></i></button>
          </div>
        </div>

        <!-- Client Totals -->
        <div class="totals">
          <div>
            <div class="outline w3-center dark pointer" @click="sortBy('active')">
              <div class="w3-padding">
                <b>{{state.admin.global.clients.active}}</b>
              </div>
              <footer class="w3-green">Active</footer>
            </div>
          </div>

          <div>
            <div class="outline w3-center dark pointer" @click="sortBy('suspended')">
              <div class="w3-padding">
                <b>{{state.admin.global.clients.suspended}}</b>
              </div>
              <footer class="w3-orange">Suspended</footer>
            </div>
          </div>
          <div>
            <div class="outline w3-center dark pointer" @click="sortBy('cancelled')">
              <div class="w3-padding">
                <b>{{state.admin.global.clients.cancelled}}</b>
              </div>
              <footer class="w3-red">Cancelled</footer>
            </div>
          </div>
          <div>
            <div class="outline w3-center dark pointer" @click="sortBy('none')">
              <div class="w3-padding">
                <b>{{state.admin.global.clients.total}}</b>
              </div>
              <footer class="w3-blue">Total</footer>
            </div>
          </div>
        </div>

        <!-- Client Cards -->
        <div class="clientsGrid">
          <article v-for="(client, idx) in state.admin.global.clients.searchClients" :key="idx">
            <div class="outline" :class="{'darkMode' : state.darkMode}">
              <div class="outline w3-white clientHeaderGrid">
                <header class="w3-padding" @click="selectClient(client)">
                  <h5 class="sectionHeader">{{client.name}}</h5>
                </header>
                <div style="display:grid; align-items: center; justify-items: right; padding-right:8px;">
                  <div class="w3-right w3-round statusLabel" v-bind:class="{'w3-green': (client.status === 'active'),'w3-red': (client.status === 'cancelled'),'w3-orange': (client.status === 'suspended')}">
                    {{client.status}}
                  </div>
                </div>
              </div>
              <div class="w3-padding pointer w3-white" @click="selectClient(client)">
                <div class="w3-row w3-display-container">
                  <p style="margin:5px 0 0">
                    {{client.email}}
                  </p>
                  <span class="w3-display-topright">
                    #{{client.id}}
                  </span>
                  <p style="margin-bottom:5px;">
                    <span v-if="client.company !== ''">{{client.company}}<br/></span>
                    <span v-else>{{client.name}}<br/></span>
                    <span>{{client.address1}}<br/></span>
                    <span v-if="client.address2">{{client.address2}}<br/></span>
                    <span>{{client.city}}, {{client.state}}  {{client.zipcode}}<br/></span>
                  </p>
                </div>
              </div>
              <!-- <footer class="w3-bar w3-dark-grey">
                <button class="w3-bar-item w3-btn w3-hover-none" style="width:50%; background:#003c43;" @click="selectClient(client)">View</button>
                <button class="w3-bar-item w3-btn w3-hover-none" style="width:50%; background:#003036;" @click="removeClient(client.email)">Delete</button>
              </footer> -->
            </div>
          </article>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dataStore from '../dataStore';

export default {
  name: "Clients",
  data() {
    return {
      state: dataStore.state,
      addScreen: false,
      width: window.innerWidth
    };
  },
  created() {
    // if (this.state.admin.client.data.email !== '') {
    //   console.log(this.state.admin.client.data)
    // }
  },
  methods: {
    searchClient() {
      this.state.admin.global.clients.searchClients = this.state.admin.global.clients.list;
      let val = this.state.admin.global.clients.searchClientTerm.trim().toLowerCase();
      if (val != '') {
        this.state.admin.global.clients.searchClients = this.state.admin.global.clients.searchClients.filter((item) => {
          if (!item.name) {item.name = ''}
          if (!item.company) {item.company = ''}
          if (!item.email) {item.email = ''}
          if (!item.address1) {item.address1 = ''}
          if (!item.address2) {item.address2 = ''}
          if (!item.city) {item.city = ''}
          if (!item.state) {item.state = ''}
          if (!item.zipcode) {item.zipcode = ''}
          return (item.name.toLowerCase().indexOf(val) > -1) ||
                 (item.company.toLowerCase().indexOf(val) > -1) ||
                 (item.email.toLowerCase().indexOf(val) > -1) ||
                 (item.address1.toLowerCase().indexOf(val) > -1) ||
                 (item.address2.toLowerCase().indexOf(val) > -1) ||
                 (item.city.toLowerCase().indexOf(val) > -1) ||
                 (item.state.toLowerCase().indexOf(val) > -1) ||
                 (item.zipcode.toLowerCase().indexOf(val) > -1);
        })
      };
    },
    clearSearch() {
      this.state.admin.global.clients.searchClientTerm = ''
      this.searchClient()
    },
    sortBy(type) {
      if (type === 'none') {
        this.state.admin.global.clients.searchClients = this.state.admin.global.clients.list;
        return;
      } else {
        let newList = [];
        for (let item of this.state.admin.global.clients.list) {
          if (item.status === type) {
            // console.log(item.status + " = " + type);
            newList.push(item);
          }
        }
        this.state.admin.global.clients.searchClients = newList;
      }
    },
    selectClient(client) {
      this.state.admin.client.data = client
      this.$router.push('/clients/clientDetails')
    },
    removeClient(email) {
      let confirmDelete = window.confirm("Do you really want to delete " + email + "?")
      if (confirmDelete) {
        dataStore.removeClient(email)
      }
    }
  }
};
</script>

<style scoped>
  .clientsGrid {display:grid; grid-template-columns: repeat(auto-fill, minmax(350px, 1fr)); grid-template-rows: auto; grid-gap: 8px;}
  .clientSearchMargin {margin-top:7px; margin-bottom:7px;}
</style>



// WEBPACK FOOTER //
// src/components/Clients.vue